/* ==========================================================================
   Discord vouch rail
   Pulls real vouches from the Cloudflare worker and rotates a few at a time
   inside the Discord card. Purely additive: if the fetch fails the panel
   removes itself and the card falls back to its normal layout.
   ========================================================================== */
(function () {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function when(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function Rail(root) {
    this.root = root;
    this.worker = root.dataset.worker;
    this.visible = Math.max(1, parseInt(root.dataset.visible, 10) || 3);
    this.speed = (parseInt(root.dataset.speed, 10) || 6) * 1000;
    this.channel = root.dataset.channel || '';
    this.viewport = root.querySelector('[data-vouch-viewport]');
    this.pool = [];
    this.cursor = 0;
    this.timer = null;

    if (!this.worker || !this.viewport) return;
    this.load();
  }

  /* One request covers several rotations, so the panel is not hammering the
     worker every few seconds. A random offset means repeat visitors do not
     always meet the same handful of reviews. */
  Rail.prototype.load = function () {
    var self = this;
    var want = this.visible * 6;

    fetch(this.worker + '?limit=1&offset=0')
      .then(function (r) { return r.json(); })
      .then(function (meta) {
        var total = meta.total || 0;
        var span = Math.max(0, total - want);
        var start = span > 0 ? Math.floor(Math.random() * span) : 0;
        self.paintStat(total, meta.average_rating);
        return fetch(self.worker + '?limit=' + want + '&offset=' + start);
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = (data && data.vouches) || [];
        // a vouch with no text says nothing useful in a small card
        self.pool = list.filter(function (v) { return v.message && v.message.trim(); });
        if (!self.pool.length) { self.fail(); return; }
        self.render(true);
        self.start();
      })
      .catch(function () { self.fail(); });
  };

  /* Nothing to show is worse than no panel: drop it and let the card reflow. */
  Rail.prototype.fail = function () {
    if (this.root && this.root.parentNode) this.root.parentNode.removeChild(this.root);
  };

  Rail.prototype.paintStat = function (total, avg) {
    var el = this.root.querySelector('[data-vouch-stat]');
    if (!el || !total) return;
    var rounded = Math.round((avg || 5) * 10) / 10;
    el.textContent = rounded + '★ · ' + total.toLocaleString() + ' reviews';
  };

  Rail.prototype.card = function (v) {
    var el = document.createElement('article');
    el.className = 'vouch';

    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars += '<span class="vouch__star' + (i > v.rating ? ' is-empty' : '') + '">★</span>';
    }

    var avatar = v.avatar
      ? '<img class="vouch__avatar" src="' + esc(v.avatar) + '" alt="" width="26" height="26" loading="lazy">'
      : '<span class="vouch__avatar vouch__avatar--blank" aria-hidden="true"></span>';

    var date = when(v.date);

    el.innerHTML =
      '<div class="vouch__stars">' + stars + '</div>' +
      '<p class="vouch__msg">' + esc(v.message) + '</p>' +
      '<div class="vouch__who">' + avatar +
        '<span class="vouch__name">' + esc(v.username || 'Anonymous') + '</span>' +
        (date ? '<span class="vouch__date">' + esc(date) + '</span>' : '') +
      '</div>';
    return el;
  };

  Rail.prototype.render = function (first) {
    var self = this;
    var next = document.createDocumentFragment();

    for (var i = 0; i < this.visible; i++) {
      var v = this.pool[(this.cursor + i) % this.pool.length];
      var card = this.card(v);
      if (!first) card.classList.add('is-entering');
      next.appendChild(card);
    }

    this.viewport.innerHTML = '';
    this.viewport.appendChild(next);

    if (!first) {
      // let the class land before clearing it, so the transition actually runs
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          self.viewport.querySelectorAll('.is-entering').forEach(function (c) {
            c.classList.remove('is-entering');
          });
        });
      });
    }
  };

  Rail.prototype.advance = function () {
    if (this.pool.length <= this.visible) return;   // nothing new to show
    this.cursor = (this.cursor + this.visible) % this.pool.length;
    this.render(false);
  };

  Rail.prototype.start = function () {
    var self = this;
    if (this.pool.length <= this.visible) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function tick() { self.timer = setTimeout(function () { self.advance(); tick(); }, self.speed); }
    tick();

    // reading a review should not have it swapped out mid-sentence
    this.root.addEventListener('mouseenter', function () { clearTimeout(self.timer); });
    this.root.addEventListener('mouseleave', function () { clearTimeout(self.timer); tick(); });

    document.addEventListener('visibilitychange', function () {
      clearTimeout(self.timer);
      if (!document.hidden) tick();
    });
  };

  function init() {
    document.querySelectorAll('[data-vouch-rail]').forEach(function (el) {
      if (!el.__rail) el.__rail = new Rail(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
